import { LegalDocument } from '@models/LegalDocument'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { LEGAL_DOCUMENTS_URL } from '@utils/urls'

const fetchLegalDocuments = (params: TableParams) =>
  SBAPI.FetchPaginated<LegalDocument[]>(LEGAL_DOCUMENTS_URL, params)

const fetchLegalDocumentBySlug = (slug: string, params?: TableParams) =>
  SBAPI.Fetch<LegalDocument>(`${LEGAL_DOCUMENTS_URL}/${slug}`, params)

const createLegalDocument = (legalDocument: LegalDocument) =>
  SBAPI.Post(LEGAL_DOCUMENTS_URL, legalDocument)

const updateLegalDocument = (legalDocument: Partial<LegalDocument>) =>
  SBAPI.Put(`${LEGAL_DOCUMENTS_URL}/${legalDocument.slug}`, legalDocument)

const updateLegalDocumentActiveVersion = (
  legalDocument: Partial<LegalDocument>,
  newActiveVersionId: number
) =>
  SBAPI.Put(`${LEGAL_DOCUMENTS_URL}/${legalDocument.slug}`, {
    ...legalDocument,
    activeVersion: newActiveVersionId,
  })

const deleteLegalDocument = (legalDocument: LegalDocument) =>
  SBAPI.Delete(`${LEGAL_DOCUMENTS_URL}/${legalDocument.slug}`)

export {
  createLegalDocument,
  deleteLegalDocument,
  fetchLegalDocumentBySlug,
  fetchLegalDocuments,
  updateLegalDocument,
  updateLegalDocumentActiveVersion,
}
